module.exports = __webpack_public_path__ + "media/3.abfeae87.mp3";